export default __webpack_public_path__ + "static/media/mobile-image-hero-1.5de3d147.jpg";